/* eslint-disable one-var */
export const NonPayment = 'Nonpayment';
export const CreditCard = 'CreditCard';
export const Check = 'Check';
export const PayPal = 'PayPal';
